// /* eslint-disable jsx-a11y/anchor-is-valid */
// import React, { useEffect, useRef } from 'react'
// import ApexCharts, { ApexOptions } from 'apexcharts'
// import { getCSS, getCSSVariableValue } from '../../../assets/ts/_utils'
// import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'

// type Props = {
//   className: string
//   name?: string
//   data?: any
// }

// const ChartsWidget3: React.FC<Props> = ({ data, className, name = 'New Suppliers' }) => {
//   const chartRef = useRef<HTMLDivElement | null>(null)
//   const { mode } = useThemeMode()

//   useEffect(() => {
//     const chart = refreshMode()

//     return () => {
//       if (chart) {
//         chart.destroy()
//       }
//     }
//   }, [chartRef, mode, data])

//   const refreshMode = () => {
//     if (!chartRef.current) {
//       return
//     }

//     const height = parseInt(getCSS(chartRef.current, 'height'))

//     const chart = new ApexCharts(chartRef.current, getChartOptions(height, data, name))
//     if (chart) {
//       chart.render()
//     }

//     return chart
//   }

//   return (
//     <div className={`card ${className}`}>
//       {/* begin::Header */}
//       <div className='card-header border-0 pt-5'>
//         <h3 className='card-title align-items-start flex-column'>
//           <span className='card-label fw-bold fs-3 mb-1'>{name}</span>
//           <span className='text-dark fw-semibold fs-7'>New Suppliers added every month</span>
//         </h3>
//       </div>

//       <div className='card-body'>
//         <div ref={chartRef} id='kt_charts_widget_3_chart' style={{ height: '350px' }}></div>
//       </div>
//     </div>
//   )
// }

// export { ChartsWidget3 }

// function getChartOptions(height: number, data: any, name: string): ApexOptions {
//   const labelColor = getCSSVariableValue('--bs-gray-900')
//   const borderColor = getCSSVariableValue('--bs-gray-200')
//   const baseColor = getCSSVariableValue('--bs-info')
//   const lightColor = getCSSVariableValue('--bs-info-light')
//   return {
//     series: [
//       {
//         name: name || 'Net Profit',
//         // data: data.data || [30, 40, 40, 90, 90, 70, 70],
//         data: data.data || [],
//       },
//     ],
//     chart: {
//       fontFamily: 'inherit',
//       type: 'area',
//       height: 350,
//       toolbar: {
//         show: false,
//       },
//     },
//     plotOptions: {},
//     legend: {
//       show: false,
//     },
//     dataLabels: {
//       enabled: false,
//     },
//     fill: {
//       type: 'solid',
//       opacity: 1,
//     },
//     stroke: {
//       curve: 'smooth',
//       show: true,
//       width: 3,
//       colors: [baseColor],
//     },
//     xaxis: {
//       // categories: data.label || ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug'],
//       categories: data.label || [],
//       axisBorder: {
//         show: false,
//       },
//       axisTicks: {
//         show: false,
//       },
//       labels: {
//         style: {
//           colors: labelColor,
//           fontSize: '12px',
//         },
//       },
//       crosshairs: {
//         position: 'front',
//         stroke: {
//           color: baseColor,
//           width: 1,
//           dashArray: 3,
//         },
//       },
//       tooltip: {
//         enabled: true,
//         formatter: undefined,
//         offsetY: 0,
//         style: {
//           fontSize: '12px',
//         },
//       },
//     },
//     yaxis: {
//       labels: {
//         style: {
//           colors: labelColor,
//           fontSize: '12px',
//         },
//         formatter: function (val) {
//           return val.toFixed(2)
//         },
//       },
//     },
//     states: {
//       normal: {
//         filter: {
//           type: 'none',
//           value: 0,
//         },
//       },
//       hover: {
//         filter: {
//           type: 'none',
//           value: 0,
//         },
//       },
//       active: {
//         allowMultipleDataPointsSelection: false,
//         filter: {
//           type: 'none',
//           value: 0,
//         },
//       },
//     },
//     tooltip: {
//       style: {
//         fontSize: '12px',
//       },
//       y: {
//         formatter: function (val) {
//           // return '$' + val + ' thousands'
//           // return val + ''
//           return val.toFixed(2)
//         },
//       },
//     },
//     colors: [lightColor],
//     grid: {
//       borderColor: borderColor,
//       strokeDashArray: 4,
//       yaxis: {
//         lines: {
//           show: true,
//         },
//       },
//     },
//     markers: {
//       strokeColors: baseColor,
//       strokeWidth: 3,
//     },
//   }
// }










/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { getCSS, getCSSVariableValue } from '../../../assets/ts/_utils'
import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'

type Props = {
  className: string
  name?: string
  data?: any
}

const ChartsWidget3: React.FC<Props> = ({ data, className, name = 'New suppliers' }) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()


  // console.log("month wiase customers.................", data)

  useEffect(() => {
    // Only create chart if data exists
    if (!data) {
      return
    }

    const chart = refreshMode()

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef, mode, data])

  const refreshMode = () => {
    if (!chartRef.current) {
      return
    }

    const height = parseInt(getCSS(chartRef.current, 'height'))

    // Add check for data before creating chart
    if (!data) {
      return
    }

    const chart = new ApexCharts(chartRef.current, getChartOptions(height, data, name))
    if (chart) {
      chart.render()
    }

    return chart
  }

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>{name}</span>
          <span className='text-dark fw-semibold fs-7'>Last 90 day trend</span>
        </h3>
      </div>

      <div className='card-body'>
        {data ? (
          <div ref={chartRef} id='kt_charts_widget_3_chart' style={{ height: '350px' }}></div>
        ) : (
          <div style={{ height: '350px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span className='text-dark'>No data available</span>
          </div>
        )}
      </div>
    </div>
  )
}

export { ChartsWidget3 }

function getChartOptions(height: number, data: any, name: string): ApexOptions {
  const labelColor = getCSSVariableValue('--bs-gray-900')
  const borderColor = getCSSVariableValue('--bs-gray-200')
  const baseColor = getCSSVariableValue('--bs-info')
  const lightColor = getCSSVariableValue('--bs-info-light')

  // Initialize chartData with proper typing
  let chartData: { data: number[]; label: string[] } = { data: [], label: [] };

  // Transform data if it exists and is in monthWise format
  if (data && typeof data === 'object') {
    if (data.data && data.label) {
      // Data is already in correct format
      chartData = data;
    } else {
      // Transform monthWise data
      const transformedData: number[] = [];
      const transformedLabels: string[] = [];

      Object.entries(data).forEach(([key, value]) => {
        if (key.includes('-')) {
          const [year, month] = key.split('-');
          const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
          const monthName = monthNames[parseInt(month) - 1];

          transformedLabels.push(`${monthName} ${year}`);
          transformedData.push(value as number);
        }
      });

      if (transformedData.length > 0) {
        chartData = { data: transformedData, label: transformedLabels };
      }
    }
  }

  return {
    series: [
      {
        name: name || 'Net Profit',
        data: chartData.data || [],
      },
    ],
    chart: {
      fontFamily: 'inherit',
      type: 'area',
      height: 350,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {},
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: 'solid',
      opacity: 1,
    },
    stroke: {
      curve: 'smooth',
      show: true,
      width: 3,
      colors: [baseColor],
    },
    xaxis: {
      categories: chartData.label || [],
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
      crosshairs: {
        position: 'front',
        stroke: {
          color: baseColor,
          width: 1,
          dashArray: 3,
        },
      },
      tooltip: {
        enabled: true,
        formatter: undefined,
        offsetY: 0,
        style: {
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
        formatter: function (val) {
          return val.toFixed(2)
        },
      },
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: '12px',
      },
      y: {
        formatter: function (val) {
          return val?.toLocaleString('en', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
        },
      },
    },
    colors: [lightColor],
    grid: {
      borderColor: borderColor,
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    markers: {
      strokeColors: baseColor,
      strokeWidth: 3,
    },
  }
}